import React from 'react';

import Icon from './Icon';
import { IconProps } from './types';

const ViewAgendaIcon = (props: IconProps) => <Icon {...props} src={'/icons/view-agenda.svg'} />;

export default ViewAgendaIcon;
